import CloseIcon from '@mui/icons-material/Close';
import Button from 'blocks/Button';
import * as S from './chip.styles';
import { ChipProps } from './chip.interface';

const Chip = ({ onRemove, text, className }: ChipProps) => {
  const handleClickRemove = () => {
    if (onRemove) onRemove();
  };

  return (
    <S.Wrapper className={className}>
      <Button iconEnd={<CloseIcon />} onClick={handleClickRemove}>
        {text}
      </Button>
    </S.Wrapper>
  );
};

export default Chip;
